import { useParams } from '@tanstack/react-router'

import { AttemptRunner } from '../features/attempt/AttemptRunner.js'

/**
 * Reads the attempt id off the route and hands it to the runner.
 *
 * Split so the runner can be mounted with an id rather than with a route tree:
 * `useParams({ from })` needs the real route to exist, and reproducing it in
 * every test buys nothing.
 */
export function AttemptScreen() {
  const { attemptId } = useParams({ from: '/$language/student/learn/attempt/$attemptId' })
  return <AttemptRunner key={attemptId} attemptId={attemptId} />
}
